"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fr_1 = __importDefault(require("date-fns/locale/fr")); //
const dateFrFR = {
    name: 'fr-FR',
    locale: fr_1.default
};
exports.default = dateFrFR;
